export { AcademicCap as default } from './AcademicCap';
